import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { sourceSchema } from "../../schemas/sourceSchema";
import { addSource } from "../../../../api/sourcesApi";
const AddSourceDialog = ({
  openAddSource,
  handleCloseAddSource,
  currentSource,
  fetchSources,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(sourceSchema),
    defaultValues: {
      name: "",
      serviceId: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.serviceId = currentSource.serviceId;
    reset({ ...defaultValues });
  }, [currentSource, reset]);

  const submitAddService = async (values) => {
    const response = await addSource(values);
    if (response.data.code != null) {
      handleSetAlertMessage(response.data.message);
      handleOpenAlert();
    } else {
      handleCloseAddSource();
      fetchSources();
    }
  };

  return (
    <div>
      <StyledDialog
        open={openAddSource}
        onClose={handleCloseAddSource}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Source</DialogTitle>
        <form onSubmit={handleSubmit(submitAddService)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Source"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddSource}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddSourceDialog;
